import React from 'react';
import { theme } from 'antd';
import { ICardComponentProps } from 'store/ducks/Global/types';
import * as Styled from './Card.styled';

const { useToken } = theme;

const CardComponent: React.FC<ICardComponentProps> = ({
  area,
  infoText,
  href,
  minHeight,
  className
}) => {
  const { token } = useToken();
  const cardToken = token as typeof token & {
    cardShadow?: string;
    cardGradient?: string;
    cardTriangle?: string;
    cardTriangleShadow?: string;
  };
  return (
    <Styled.StyledLinkButton to={href} className={className}>
      <Styled.StyledCard
        token={token}
        minHeight={minHeight}
        cardShadow={cardToken.cardShadow}
        cardGradient={cardToken.cardGradient}
        cardTriangle={cardToken.cardTriangle}
        cardTriangleShadow={cardToken.cardTriangleShadow}
      >
        <span>{area}</span>
        <Styled.StyledMeta token={token} description={infoText} />
      </Styled.StyledCard>
    </Styled.StyledLinkButton>
  );
};

export default CardComponent;
